/* istanbul ignore file */
export enum Language {
  en = 'en',
  es = 'es',
}

export enum NavigationTabKey {
  about = 'about',
  assessment = 'assessment',
  candidatePipeline = 'candidatePipeline',
  candidateProfile = 'candidateProfile',
  careerJourney = 'careerJourney',
  careerProgression = 'careerProgression',
  hiring = 'hiring',
  hiringOverview = 'hiringOverview',
  home = 'home',
  myCareer = 'myCareer',
  myTeam = 'myTeam',
  openJobs = 'jobs',
  profile = 'profile',
  tellUsAboutYourself = 'tellUsAboutYourself',
  training = 'training',
  settings = 'settings',
}

export enum NavigationPath {
  about = '/about',
  assessment = '/myCareer/assessment',
  authend = '/authend',
  authstart = '/authstart',
  careerJourney = '/myCareer/careerJourney',
  careerJourneyPlayer = '/myCareer/careerJourney/player',
  careerProgressionV2 = '/myCareer/careerProgression',
  defaultPath = '/',
  hiring = '/hiring',
  home = '/home',
  myCareer = '/myCareer',
  myTeam = '/myTeam',
  openJobs = '/myCareer/jobs',
  profile = '/profile',
  profileDegreesAndCertifications = '/profile/degreesAndCertifications',
  profileJobDetail = '/profile/jobProfile',
  profileMySkills = '/profile/mySkills',
  profileWorkExperience = '/profile/workExperience',
  refresh = '/refresh',
  systemMaintenance = '/systemMaintenance',
  teamsConfig = '/config',
  tellUsAboutYourself = '/tellUsAboutYourself',
  training = '/myCareer/training',
  trainingCourses = '/myCareer/training/courses',
  trainingPlayer = '/myCareer/training/player',
  trainingRecommended = '/myCareer/training/recommended',
  unAuthorizedPage = '*',
  settings = '/settings',
}

export enum MyCoursesStatus {
  inProgress = 'in_progresss',
  saved = 'pending',
  completed = 'complete',
}

export enum TrainingStatus {
  inProgress = 'in_progresss',
  pending = 'pending',
  completed = 'complete',
  notStarted = 'not_started',
  expired = 'expired',
}

export enum EnrollmentStatus {
  inProgress = 'InProgress',
  completed = 'Completed',
}

export enum ReadFields {
  SuggestedSkills = 'suggestedSkills',
  MySkills = 'mySkills',
  CareerPreferences = 'careerPreferences',
  InterestedRoles = 'interestedRoles',
  AssessmentCompleted = 'assessmentCompleted',
  DegreesAndCertificationsCompleted = 'degreesAndCertificationsCompleted',
  NextBestRoleCompleted = 'nextBestRoleCompleted',
  ResumeCompleted = 'resumeCompleted',
  SkillsCompleted = 'skillsCompleted',
  WorkExperienceCompleted = 'workExperienceCompleted',
  Resume = 'resume',
  CareerProgressionViewed = 'careerProgressionViewed',
}

export enum ProfileCompletenessItem {
  AssessmentCompleted = 'AssessmentCompleted',
  DegreesAndCertificationsCompleted = 'DegreesAndCertificationsCompleted',
  NextBestRoleCompleted = 'NextBestRoleCompleted',
  ResumeCompleted = 'ResumeCompleted',
  SkillsCompleted = 'SkillsCompleted',
  WorkExperienceCompleted = 'WorkExperienceCompleted',
}

export enum AssessmentType {
  All = 'All',
  Behavioral = 'Behavioral',
  KfaBehavioral = 'BehavioralAssess1',
  StylesClimate360Setup = 'StylesClimate360Setup',
  Styles = 'Styles',
  Climate = 'Climate',
  Competency360Setup = 'Comp360Setup',
  Competency360Assessment = 'Comp360',
  TechnicalSetup = 'TechnicalSetup',
  ThreeSixtyAssessment = 'ThreeSixtyAssessment',
  TechnicalSkillsAssessment = 'TechnicalSkillsAssessment',
}

export enum AssessmentTypeIndex {
  TechnicalSkillsAssessment = 0,
}

export enum AssessmentProviderIndex {
  HireMee = 0,
}

export enum AssessmentStatus {
  ComingSoon = 'ComingSoon',
  Complete = 'Complete',
  Completed = 'Completed',
  DeadlinePassed = 'DeadlinePassed',
  Expired = 'Expired',
  InProgress = 'InProgress',
  InProgressInterrupted = 'InProgressInterrupted',
  Locked = 'Locked',
  New = 'New',
  NotInvited = 'NotInvited',
  NotSettedUp = 'NotSettedUp',
  NotStarted = 'NotStarted',
  SettedUp = 'SettedUp',
  Sufficient = 'Sufficient',
}

export enum AssessmentStatusTypes {
  Completed = 2, // for PastActivity tab
  Available = 5, // for Available tab
  Results = 6, // for Results tab
}

export enum AssessmentChoice {
  All,
  AssessingEmployee,
  AssessingOthers,
}

export enum LmsServiceProviders {
  GO1 = 'go1',
  KFLEARN = 'kflearn',
  UDEMY = 'udemy',
  SKILLSOFT = 'skillsoft',
  PLURALSIGHT = 'pluralsight',
}

export enum LmsServiceProviderIndex {
  GO1 = 1,
  KFLEARN = 2,
  UDEMY = 3,
  SKILLSOFT = 4,
  PLURALSIGHT = 5,
}

export enum FocusSkillType {
  Skill = 'skill',
  Competency = 'competency',
}

export enum LMSTypeAhead {
  Skills = 'LMSTypeAheadSkills',
  Competency = 'competency',
}

export enum FocusSkillTypeIndex {
  skill = 1,
  lmstypeaheadskills = 1,
  competency = 2,
}

export enum AssessmentLevels {
  Basic = 'Basic level',
  Intermediate = 'Intermediate level',
  Advanced = 'Advance level',
}

export enum AssessmentLevelIndex {
  Basic = 1,
  Intermediate = 2,
  Advanced = 3,
}

export enum AssessmentTab {
  Available = 'available',
  Results = 'results',
  PastActivity = 'pastActivity',
}

export enum AssessmentAccordionType {
  PROJECT = 'PROJECT ASSESSMENT',
  SELF = 'SELF ASSESSMENT',
}

export enum AssessmentsFilterOptions {
  STATUS = 'Status',
  SURVEY_DEADLINE = 'Survey Deadline',
}

export enum AssessmentProjectType {
  ProfessionalDevelopment = 'ProfessionalDevelopment',
  LearningAgility = 'LearningAgility',
  Potential = 'Potential',
  LeadershipSelection = 'LeadershipSelection',
}

export enum CompetencyServeyResultTabs {
  Summary = '0',
  Details = '1',
  AdditionalComments = '2',
}

export enum AdditionalCommentsTabs {
  AllComments = 'allComments',
  Self = 'self',
  Manager = 'manager',
  AllOtherRaters = 'allOtherRaters',
}

export enum CourseEntryLevels {
  AllLevels = 'Suitable for everyone',
  Beginner = 'Beginner',
  Intermediate = 'Intermediate',
  Advanced = 'Advanced',
}

export enum RecommendationFeedbackType {
  CAREER_PROGRESSION = '0',
  COURSES = '1',
}

export enum RecommendationButtonType {
  LIKE = 1,
  DISLIKE = 0,
}

export enum SectionName {
  TrainingEditFocusArea = 'Edit Focus Area in Training',
}

export enum SurveyProgressStatus {
  NOTSTARTED = 'NotStarted',
  INPROGRESS = 'InProgress',
  COMPLETED = 'Completed',
}

export enum AssessmentActionType {
  BUTTON = 'BUTTON',
  LINK = 'LINK',
}

export enum AuthenticationStatus {
  Initial,
  Unauthenticated,
  InProgress,
  Failed,
  Succeeded,
}

export enum ErrorMessage {
  userCancelled = 'authErrorUserCancelled',
  defaultError = 'defaultLoginError',
  loginFailureError = 'yourAreNotAuthorizedToAccessKFApps',
  invalidUserAgent = 'appNotSupportedInMobile',
  commonError = 'commonErrorMessage',
  executiveUserError = 'executiveUserErrorMessage',
}

export enum UserDialogEvents {
  BACKDROP_CLICK = 'backdropClick',
  ESCAPE_KEYDOWN = 'escapeKeyDown',
}

export enum SkillsMatchLevel {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

export enum ViewMoreDetailsTabs {
  Overview = '0',
  BehavioralCompetencies = '1',
}

export enum CareerProgressionRoleAction {
  ADD = 'add',
  REMOVE = 'remove',
}

export enum CoursesFilterOptions {
  FOCUS_AREA = 'Focus Area',
  PROFICIENCY_LEVEL = 'Proficiency Level',
  DURATION = 'Duration',
}

export enum PaginationType {
  Previous = 'prev',
  Next = 'next',
}

export enum LearningElementTypeIndex {
  skill = 1,
  competency = 2,
}

export enum LearningActivityTypeIndex {
  Course,
  PreAssessment,
  PostAssessment,
}

export enum CareerJourneyStatus {
  Created,
  InProgress,
  Completed,
}

export enum LearningProgressStatus {
  NotStarted,
  InProgress,
  Completed,
  Expired,
}

export enum LearningElementRenderingOrderIndex {
  skill,
  competency,
}

export enum InterestedRoleCareerJourneyStatus {
  NotCreated,
  Created,
  Completed,
}

export enum CareerJourneyCreateActionIndex {
  NOTSTARTED,
  STARTED,
  SUCCESS,
  FAILED,
}

export enum HttpResponseStatusCodes {
  OK = 200,
  CREATED = 201,
  RESETCONTENT = 205,
}

export enum RequisitionChartStatusDotVariant {
  SOLID = 'solid',
  HALO = 'halo',
  COMBINED = 'combined',
}

export enum EmploymentType {
  fullTimeEmployee = 'Full Time Employee',
  partTimeEmployee = 'Part Time Employee',
  contractorEmployee = 'Contractor',
}

export enum SkillKey {
  MATCHING = 'matching',
  MISSING = 'missing',
}

export enum RBAC_ROLE {
  HIRING_MANAGER = 'HIRING_MANAGER',
  TEAM_MANAGER = 'TEAM_MANAGER',
  EMPLOYEE = 'EMPLOYEE',
  KF_ASSESS_USER = 'KF_ASSESS_USER',
  KF_ASSESS_DEMO_USER = 'KF_ASSESS_DEMO_USER',
}

export enum RBAC_RESOURCE {
  HOME = 'Home Dashboard',
  MY_TEAM = 'My Team',
  HIRING = 'Hiring',
  CAREER_PROGRESSION = 'Career Progression',
  CAREER_JOURNEY = 'ICJ',
  TRAINING = 'Training',
  JOBS = 'Open Jobs',
  KF_ASSESS1_ASSESSMENT = 'KF Assess 1 Assessments',
  CTD_ASSESSMENT = 'CTD Assessment',
  STYLES_AND_CLIMATE_ASSESSMENT = 'Styles and Climate Survey',
  BEHAVIORAL_360_ASSESSMENT = 'Behavioral 360 Assessment',
  TECHNICAL_SKILL_360_ASSESSMENT = 'Technical Skill 360 Assessment',
  TECHNICAL_SKILL_ASSESSMENT = 'Technical Skill Assessment',
  EMPLOYEE_PROFILE = 'Employee Profile',
  EMPLOYEE_SUCCESS_PROFILE = 'Employee Success Profile',
  FYI_BOT = 'FYI Bot',
  TUAY = 'Tell Us About Yourself',
  ABOUT = 'About App',
}

export enum RBAC_OPERATION {
  ALL = 'all',
  READ = 'read',
  WRITE = 'write',
  DELETE = 'delete',
}

export enum RBAC_PERSONA {
  UNIFIED = 'UNIFIED',
  HIRING_MANAGER = 'HIRING_MANAGER',
  TEAM_MANAGER = 'TEAM_MANAGER',
  EMPLOYEE = 'EMPLOYEE',
  KF_ASSESS_USER = 'KF_ASSESS_USER',
  KF_ASSESS_DEMO_USER = 'KF_ASSESS_DEMO_USER',
}

// KFONE Keycloak realm roles mapped as constants for use across the app
export const KFONE_ROLE = {
  DEFAULT_ROLES_DEV: 'default-roles-dev',
  TALENTSUITE_ADMIN: 'talentsuite_admin',
  TALENTSUITE_USER: 'talentsuite_user',
  INSIGHT_ADMIN: 'insight_admin',
  PAY_ADMIN: 'pay_admin',
  ORGANIZATIONAL_DATA_COLLECTION_ADMIN: 'organizational_data_collection_admin',
  HIRING_MANAGER: 'hiring_manager',
  CLIENT_ADMIN: 'client_admin',
  NIMBLE_RECRUITER: 'nb_recruiter',
} as const;

export type KFoneRealmRole = (typeof KFONE_ROLE)[keyof typeof KFONE_ROLE];

// KFONE permission objects (rsname/scope) to align with Keycloak UMA
export const KFONE_PERMISSIONS = {
  HIRING: { rsname: 'hiring', scope: 'access' },
} as const;

export type KFonePermission = (typeof KFONE_PERMISSIONS)[keyof typeof KFONE_PERMISSIONS];

export enum Ic2fxComponentType {
  loader = 'loader',
  errorScreen = 'errorScreen',
}

export enum Ic2fxErrorType {
  forbidden = 'forbidden',
}

export enum DurationType {
  minutes = 'minutes',
  seconds = 'seconds',
}

export enum CoursesSearchProduct {
  KFCT = 1,
  KF_ASSESS = 2,
}

export enum FocusSkillName {
  All = 'all',
  Clear = 'clear',
}

export enum TUAYSections {
  tuay = 'tuay',
  aboutYourself = 'aboutYourself',
  completed = 'completed',
  submitted = 'submitted',
  error = 'error',
}

export enum TUAYQuesCode {
  DemJob = 'Dem_Job', //Job Title
  DemLvl = 'Dem_Lvl', //Level in the organization
  DemBoD = 'Dem_BoD', //Board of Directors
  DemScp = 'Dem_Scp', //Scope of authority
  DemCtb = 'Dem_Ctb', //Contributor Type
  DemFct = 'Dem_Fct', //Functional Area
  DemSub = 'Dem_Sub', //Subfunctional area
  DemSubOth = 'Dem_Sub_Oth', //Other subfunction
  DemCryEmp = 'Dem_Cry_Emp', //Current Work Location
  DemGen = 'Dem_Gen', //Gender
  DemGenOth = 'Dem_Gen_Oth', //Other gender
  DemBth = 'Dem_Bth', //Year of birth
  DemCryLiv = 'Dem_Cry_Liv', //Current country location
  DemCryRsd = 'Dem_Cry_Rsd', //Raised country location
  DemEdu = 'Dem_Edu', //Level of education completed
  DemYrsPos = 'Dem_Yrs_Pos', //Years in current position
  DemMosPos = 'Dem_Mos_Pos', //Months in current position
  DemYrsEmp = 'Dem_Yrs_Emp', //Years with current employer
  DemMosEmp = 'Dem_Mos_Emp', //Months with current employer
  DemYrsMgt = 'Dem_Yrs_Mgt', //Years in management
  DemMosMgt = 'Dem_Mos_Mgt', //Months in management
}

export enum TUAYFunctionalAreas {
  GeneralAndAdministrativeSupport = 'Fct_01',
  Communications = 'Fct_02',
  CustomerServiceOrCallCenter = 'Fct_03',
  Engineering = 'Fct_04',
  ExecutiveOrGeneralManagement = 'Fct_05',
  FinanceAndAccounting = 'Fct_06',
  SafetyHealthAndEnvironment = 'Fct_07',
  HumanResources = 'Fct_08',
  InformationTechnology = 'Fct_09',
  LegalAndCompliance = 'Fct_10',
  BankingAndInsurance = 'Fct_11',
  LogisticsOrSupplyChain = 'Fct_12',
  Marketing = 'Fct_13',
  DigitalMarketing = 'Fct_14',
  ProjectAndProgramManagement = 'Fct_15',
  Operations = 'Fct_16',
  PropertyManagementAndConstruction = 'Fct_17',
  QualityAssurance = 'Fct_18',
  ResearchAndDevelopment = 'Fct_19',
  Sales = 'Fct_20',
  Trading = 'Fct_21',
  RiskManagement = 'Fct_22',
  AnalyticsAndDataScience = 'Fct_23',
  StrategyAndPolicyCreationAndImplementation = 'Fct_24',
  EducationAndTraining = 'Fct_25',
  PublicSafetyAndMilitary = 'Fct_26',
  GeoscienceAgricultureAndForestry = 'Fct_27',
  HealthCare = 'Fct_28',
  HospitalityAndTourism = 'Fct_29',
  Retail = 'Fct_30',
}

export enum TUAYOrgLevels {
  'CEO' = 'Lvl_01',
  'CSuite' = 'Lvl_02',
  'SeniorLeader' = 'Lvl_03',
  'ManagerOfManagers' = 'Lvl_04',
  'FirstLevelSupervisor' = 'Lvl_05',
  'IndividualContributor' = 'Lvl_06',
}

export enum TUAYAnswerCodes {
  PreferToSelfDescribe = 'Sex_02_06',
}

export enum TUAYLabelArguments {
  Country = 'country',
  Education = 'education',
  MainQuestion = 'main',
  OrgLevelBranchedQuestions = 'orgLevelBranchedQuestions',
  FunctionalAreaBranchedQuestions = 'functionalAreaBranchedQuestions',
  SameLabelAndAnswerCode = 'SameLabelAndAnswerCode',
  DifferentLabelAndAnswerCode = 'DifferentLabelAndAnswerCode',
}

export enum InviteFromOthers {
  dueSoon = 'Due Soon',
  new = 'New',
}

export enum DialogModalCloseType {
  FINISH = 'FINISH',
  CANCEL = 'CANCEL',
}

export enum FeedbackHiringDecision {
  RECOMMENDS = 'yes',
  DOESNTRECOMMEND = 'no',
  NOTSURE = 'notSure',
}

export enum FeedbackDetailResponseSelectedOption {
  NA = 'NA',
}

export enum FeedbackDetailResponseItemsName {
  RECOMMENDHIRE = 'recommendhire',
}

export enum InterviewFeedbackQuestionType {
  LIKART_WITH_NA = 'likart_with_na',
  YES_NO_NA = 'yes_no_unsure_with_comments',
}

export enum DateRangeType {
  START_DATE = 'START_DATE',
  END_DATE = 'END_DATE',
}

export enum HomeComponentKey {
  profileCompletion = 'profileCompletion',
  assessment = 'assessment',
  recentHiringActivity = 'recentHiringActivity',
}
